import { useEventBus } from '@vueuse/core'
import type { BlockPath, ExtendedBlock } from '../types'
import { findBlockPathById } from 'widget-components/integrations/CustomPage/utilities/findBlockPathById'

export type BlockBuilderUpdateBlockByPathPayload = {
    block: Partial<ExtendedBlock>
    path: BlockPath
}

export const emitBlockUpdate = (_path: BlockPath | undefined, block: Partial<ExtendedBlock>) => {
    const path = _path?.length ? _path : (block.id ? findBlockPathById(block.id) : undefined)
    if (path) {
        useEventBus<BlockBuilderUpdateBlockByPathPayload>('update-block-by-path').emit({ path, block })
    } else {
        // eslint-disable-next-line no-console
        console.warn(`No path found for block`, block)
    }
}
